import * as React from 'react';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { getCatalogSellerName } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getSellerPhoneNumber } from '@/redux/modules/sellerDetail';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { openSendSellerMessageModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import GetAnswersModalFooter from '../Modals/Shared/GetAnswersModalFooter';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

type Props = {
    catalogId: number;
    sellerId: number;
};

const BidLimitExceededMessage = ({ catalogId, sellerId }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();

    const sellerName = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const phoneNumber = useAppSelector((state) => getSellerPhoneNumber(state, sellerId));

    const showSendSellerMessageModal = React.useCallback(() => {
        const messageDetails = {};
        const subject = formatMessage({
            id: 'bidLimitExceededMessage.subject',
        });

        dispatch(openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject));
    }, [dispatch, formatMessage, sellerId, sellerName]);

    return (
        <>
            <BodyPrimary>
                <FormattedMessage
                    id="bidLimitExceededMessage.text"
                    values={{
                        link: (
                            <InlineButton
                                key="bid-limit-exceeded-message-link"
                                onClick={showSendSellerMessageModal}
                            >
                                {formatMessage({
                                    id: 'bidLimitExceededMessage.linkText',
                                })}
                            </InlineButton>
                        ),
                        sellerName,
                        sellerPhone: <Link to={`tel:${phoneNumber}`}>{phoneNumber}</Link>,
                    }}
                />
            </BodyPrimary>
            <StyledGetAnswersModalFooter>
                <GetAnswersModalFooter sellerId={sellerId} />
            </StyledGetAnswersModalFooter>
        </>
    );
};

export default BidLimitExceededMessage;

const StyledGetAnswersModalFooter = styled.div`
    margin-top: 24px;
    text-align: center;
`;
